// extracted by mini-css-extract-plugin
export default {"more_button":"more-button_more_button__cyQYR","more_menu_wrapper":"more-button_more_menu_wrapper__e-TeK"};